import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue'),
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('./views/Dashboard.vue'),
            meta: {
                isSecured: true,
                pageClasses: 'page-dashboard page-light',
            },
        },
        {
            path: '/loader',
            name: 'loader',
            component: () => import('./views/Loader.vue'),
        },
        {
            path: '/sign-in',
            name: 'signIn',
            component: () => import('./views/SignIn.vue'),
            meta: {
                isOnlyUnAuth: true,
            },
        },
        {
            path: '/lost-password',
            name: 'lostPassword',
            component: () => import('./views/LostPassword.vue'),
            meta: {
                isOnlyUnAuth: true,
            },
        },
        {
            path: '/reset-password/:token',
            name: 'resetPassword',
            component: () => import('./views/ResetPassword.vue'),
            props: true,
        },
        {
            path: '/notification',
            name: 'notification',
            component: () => import('./views/Notification.vue'),
            meta: {
                isSecured: true,
            },
        },
        {
            path: '/user/:id',
            name: 'userDetail',
            component: () => import('./views/UserDetail.vue'),
            props: true,
            meta: {
                isSecured: true,
            },
        },
        {
            path: '/my-profile',
            name: 'userSettings',
            component: () => import('./views/UserSettings.vue'),
            meta: {
                isSecured: true,
                pageClasses: 'page-light',
            },
        },

        {
            path: '/users',
            name: 'users',
            component: () => import('./views/Users.vue'),
            meta: {
                isSecured: true,
                pageClasses: 'page-light',
            },
        },
        {
            path: '/teams',
            name: 'teams',
            component: () => import('./views/Teams.vue'),
            meta: {
                isSecured: true,
                pageClasses: 'page-light',
            },
        },

        {
            path: '/team/:id',
            name: 'teamDetail',
            component: () => import('./views/TeamDetail.vue'),
            props: true,
            meta: {
                isSecured: true,
            },
        },
        {
            path: '/my-team',
            name: 'myTeam',
            component: () => import('./views/MyTeam.vue'),
            meta: {
                isSecured: true,
                pageClasses: 'page-light',
            },
        },

        {
            path: '/messages',
            name: 'messages',
            component: () => import('./views/Messages.vue'),
            meta: {
                isSecured: true,
                pageClasses: 'page-light',
            },
        },
        {
            path: '/messages/:id',
            name: 'messagesDetail',
            component: () => import('./views/MessageDetail.vue'),
            props: true,
            meta: {
                isSecured: true,
                pageClasses: 'page-light',
            },
        },

        {
            path: '/registration',
            name: 'registration',
            component: () => import('./views/Registration.vue'),
            meta: {
                isOnlyUnAuth: true,
            },
        },
        {
            path: '/user-activation/:token',
            name: 'userActivation',
            component: () => import('./views/UserActivation.vue'),
            props: true,
        },
        {
            path: '/tournament',
            name: 'tournament',
            component: () => import('./views/Tournament.vue'),
            meta: {
                pageClasses: 'page-light',
            },
        },
        {
            path: '/tournament/:id',
            name: 'tournamentDetail',
            component: () => import('./views/TournamentDetail.vue'),
            props: true,
            meta: {
                pageClasses: 'page-light',
            },
        },
        {
            path: '/rules',
            name: 'rules',
            component: () => import('./views/Rules.vue'),
            meta: {
                pageClasses: 'page-rules',
            },
        },
        {
            path: '/gdpr',
            name: 'gdpr',
            component: () => import('./views/Gdpr.vue'),
            meta: {
                pageClasses: 'page-gdpr',
            },
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('./views/Contact.vue'),
        },
        {
            path: '*',
            name: 'notFound',
            component: () => import('./views/NotFound.vue'),
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
});

router.beforeEach((to, from, next) => {
    const isLoggedIn = store.getters['user/isLoggedIn'];
    if (to.matched.some(route => route.meta.isSecured) && !isLoggedIn) {
        localStorage.setItem('login-backlink', JSON.stringify(to));
        next({ name: 'signIn' });
    } else if (to.matched.some(route => route.meta.isOnlyUnAuth) && isLoggedIn) {
        next({ name: 'dashboard' });
    }

    next();
});

export default router;
